"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourPartnerInTalentAcquisition() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative w-full min-h-[80vh] md:min-h-screen overflow-hidden bg-dark-background">
      {}
      <div className="flex flex-col items-center justify-center min-h-[80vh] md:min-h-screen px-6 py-16 md:px-12 lg:px-20">
        {}
        <div ref={headlineRef} className={`max-w-4xl text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${headlineVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <h1 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-foreground-dark leading-tight mb-6">Refreshing and Innovative Social Care Management Recruitment and Retention</h1>
          <p className="text-foreground-dark/90 text-lg md:text-xl lg:text-2xl font-light mb-8">Specialist management recruitment solution for care providers that embeds psychometrics and enhanced retention.</p>
        </div>

        {}
        <div ref={buttonRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-300 ${buttonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Link to="/ContactUsPage">
            <Button size="lg" className="btn-primary text-lg px-8 py-4 shadow-medium hover:shadow-[0_0_24px_rgba(215,223,35,0.5)] transition-shadow duration-[var(--duration-medium)]">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}